import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { SigningRemindersUnlinkPayload } from 'Interfaces/Document';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((payload: SigningRemindersUnlinkPayload) =>
    $actions.documentSign.unlinkSigningReminders(dispatch, payload),
  );
};
